module.exports = __webpack_public_path__ + "assets/b88c1c59cbd9b2b28ede5f082f26cbd3.mp3";